export const drawMarkersArticle = {
    id: 'draw-markers',
    title: 'Метки',
    category: 'Режим рисования',
    requiredModule: null,
    sandboxType: null,
    summary: 'Точечные метки: въездные группы, инфраструктура, инженерные точки, иконки из каталога и загрузка своих изображений.',
    markdown: `
> **Инструмент «Метки»** предназначен для точечной привязки важных объектов посёлка: КПП, шлагбаумов, детских городков, скважин, гидрантов, фонарей и мест отдыха.

---

## 1. Сценарии использования

:::grid cols=2
:::card icon="shield" title="1. Въездные группы и охрана"
КПП, автоматические шлагбаумы, въездные ворота, посты охраны и точки установки камер видеонаблюдения.
:::

:::card icon="trees" title="2. Инфраструктура и отдых"
Детские и спортивные площадки, зоны барбекю, пляжи, пирсы, арт-объекты и видовые площадки.
:::

:::card icon="settings" title="3. Инженерные точки"
Пожарные гидранты, трансформаторные подстанции (ТП), скважины, газовые редукторы (ГРПШ) и колодцы сетей.
:::

:::card icon="map-pin" title="4. Сервис и навигация"
Гостевые парковки, остановки маршрутного транспорта, указатели улиц и площадки для сбора ТБО.
:::
:::

---

## 2. Установка в 1 клик

В отличие от полигонов и линий, расстановка меток происходит моментально:

:::tip Быстрое создание
Выберите инструмент «Метки» на панели и кликните в нужное место карты — точка сразу появится на карте, и справа откроется паспорт для заполнения названия, категории и прикрепления фото.
:::

---

## 3. Каталог иконок и свои изображения

Чтобы каждый тип объекта легко считывался на карте с первого взгляда, меткам назначаются визуальные пиктограммы:

* **Категории с иконками:** выбор категории из классификатора автоматически привязывает к точке соответствующий значок и цвет (например, синяя капля для гидранта, зелёная ёлочка для парка, красный щит для охраны).
* **Загрузка собственных изображений:** вы можете загрузить уникальную иконку, логотип партнёра или фото пиктограммы для любого нестандартного объекта.

---

## 4. Паспорт и наполнение точки информацией

Для каждой метки доступен полноценный паспорт объекта:
* **Фотографии:** фото реального объекта (например, внешний вид шлагбаума или установленного оборудования).
* **Документация и ссылки:** инструкции по эксплуатации оборудования, регламенты пропускного режима или паспорта скважин.
* **Контакты и описание:** телефоны дежурной службы, график работы или технические параметры.
`
};
